import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      {...props}
      width={props.width || 19}
      height={props.height || 19}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Circle cx={9.5} cy={9.5} r={9.5} fill={props.bgColor || "#FF2E00"} />
      <Path
        d="M10.325 9.5l3.504-3.505a.582.582 0 10-.825-.824L9.5 8.676 5.996 5.17a.582.582 0 10-.825.824L8.675 9.5l-3.504 3.505a.582.582 0 10.825.824L9.5 10.325l3.505 3.504a.581.581 0 00.824 0 .582.582 0 000-.824L10.324 9.5z"
        fill={props.color || "#fff"}
        stroke={props.color || "#fff"}
        strokeWidth={0.5}
      />
    </Svg>
  );
}

export default SvgComponent;
